export default __webpack_public_path__ + "static/media/cart-empty-state.3ef0164f.svg";